import React from 'react';

// Building blocks for loading skeletons on the student and teacher sides.
// Page-specific skeletons live next to their pages:
//   student → pages/student/StudentSkeletons.jsx
//   teacher → components/teacher/TeacherSkeletons.jsx
// AI work (generating, scoring, thinking) uses the sparkle Loader instead.
//
// The bone colour follows the student theme's ink when one is applied and
// falls back to slate everywhere else (teacher pages, app start-up).

const BONE_BG = 'color-mix(in srgb, var(--st-ink, #0f172a) 8%, transparent)';

/** One grey placeholder block. Size and shape come from `className`. */
export function Bone({ className = '', style }) {
  return (
    <span aria-hidden="true"
      className={`block rounded-md animate-pulse motion-reduce:animate-none ${className}`}
      style={{ background: BONE_BG, ...style }} />
  );
}

/** Wraps a skeleton so screen readers hear one "loading" message, not the bones. */
export function SkeletonRegion({ label, testId, className = '', children }) {
  return (
    <div role="status" aria-busy="true" data-testid={testId} className={className}>
      <span className="sr-only">{label}</span>
      {children}
    </div>
  );
}

/** A file preview (PDF, image, office doc) filling its frame while it downloads. */
export function FilePreviewSkeleton({ label = 'Loading preview…', testId = 'file-preview-loading', className = 'w-full h-full min-h-[50vh] p-6 flex' }) {
  return (
    <SkeletonRegion label={label} testId={testId} className={className}>
      <Bone className="flex-1 rounded-xl" />
    </SkeletonRegion>
  );
}

export const range = (n) => Array.from({ length: n }, (_, i) => i);
